import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { distinctUntilChanged, map, switchMap, timeout } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {

  private loadingSub$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private pendingCount$: BehaviorSubject<number> = new BehaviorSubject(0);
  loading$: Observable<boolean> = this.loadingSub$.asObservable();
  private delay = 300;

  constructor() {
    this.pendingCount$.pipe(
      map(x => Boolean(x)),
      distinctUntilChanged(),
      switchMap(x => x ? of(x) : of(x).pipe(timeout(this.delay)))
    ).subscribe(
      show => { this.loadingSub$.next(show); }
    );
  }


  public attach = () =>
    this.pendingCount$.next(this.pendingCount$.value + 1);
    
  
  public deattach = () =>
    this.pendingCount$.next(this.pendingCount$.value === 0 ? 0 : this.pendingCount$.value - 1);

  public show = () =>
    this.pendingCount$.next(1);


  public hide = () =>
    this.pendingCount$.next(0);

}
